module.exports = __webpack_public_path__ + "media/images/starworks-logo-f4efb41fc1468f9193112e3fefb1e10a.svg";